import {ValueObject} from '@s-ui/domain'

export class UpdatePasswordResponseUserValueObject extends ValueObject {
  #token
  #authenticationToken

  /**
   * @param {String} token
   * @param {String} authenticationToken
   * */
  static create({token, authenticationToken}) {
    return new UpdatePasswordResponseUserValueObject({token, authenticationToken})
  }

  constructor({token, authenticationToken}) {
    super()

    this.#token = token
    this.#authenticationToken = authenticationToken
  }

  toJSON() {
    return {token: this.#token, authenticationToken: this.#authenticationToken}
  }
}
